import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import StaticContext from '~/context/common/StaticContext';
import { clearFeatureCookies } from '~/utilities/featureBranch';

export default function ClearButton() {
  const { clientId, kubernetesAppName } = useContext(StaticContext);

  const handleClear = clearFeatureCookies(kubernetesAppName, clientId);

  return (
    <Clickable
      element="span"
      onClick={handleClear}
      className="pointer-events-auto px-8 text-2xl leading-none"
      data-analytics-id="Clear feature branch"
      data-testid="clear-feature-branch"
      title="Clear feature branch"
    >
      ×
    </Clickable>
  );
}
